import React, { Fragment } from 'react';
import dayjs from 'dayjs';
import { RemoveTrainingProps, TeamMemberApiTraining } from './TeamMemberTrainings.types';
import { Label } from '../../../common/Label/Label';
import { TEAM_MEMBER_DETAILS } from '../../../../lib/constants/labelKeys';
import { getDaysOverdue } from '../../../../lib/utils/getOverdueText';
import styles from './TeamMemberTrainings.module.scss';
import { GlobalConfiguration } from '../../../common/model';
import { NULL_INVERSE_SORT } from '../../../../lib/constants/courses';
import CardBadge from '../../base/CourseCard/CardBadge';
import { getRemoveColumn } from '../../../common/PureTable/PureTable.utils';
import LitmosTrainingLink, { getCustomLinkElement } from '../../base/LearningLink/LearningLink';
import { getTrainingStatusKey } from '../../base/TableManager/TableManager.utils';
import { getTrainingType } from '../../../../lib/utils/trainings/typesChecking';

export const adaptToMemberTraining =
  ({ config, itemsRemovingState, onBinClickHandler }: { config: GlobalConfiguration | null } & RemoveTrainingProps) =>
  (userTraining: TeamMemberApiTraining) => {
    const {
      id,
      dateCompleted = '',
      name,
      type,
      dueDate,
      compliantTill,
      startDate,
      teamAssignment,
      status,
    } = userTraining;
    const { globalDateFormat } = config ?? {};
    const expired = getDaysOverdue(new Date(compliantTill ?? ''));

    return {
      ...userTraining,
      name: (
        <LitmosTrainingLink
          key={`|${name}`}
          className={styles.courseLink}
          type={getTrainingType(type)}
          id={id}
          name={name}
          ContentElement={getCustomLinkElement({ asButton: false, label: name })}
        />
      ),
      status: (
        <CardBadge
          key={getTrainingStatusKey(status)}
          dueDate={dueDate}
          status={status}
          className={styles.badge}
          withNotStartedBadge
        />
      ),
      dateCompleted: (
        <Fragment key={`|${dateCompleted ?? ''}|${NULL_INVERSE_SORT}`}>
          {dateCompleted ? dayjs(dateCompleted).format(globalDateFormat) : ''}
        </Fragment>
      ),
      compliantTill: compliantTill ? (
        <Fragment key={`|${compliantTill}`}>
          <span className={styles.compliantTill}>{dayjs(compliantTill).format(globalDateFormat)}</span>
          {expired ? <Label name={TEAM_MEMBER_DETAILS.EXPIRED_SUFFIX} className={styles.expiredSuffix} /> : ''}
        </Fragment>
      ) : (
        ''
      ),
      remove: getRemoveColumn({
        onBinClickHandler,
        itemsRemovingState,
        id,
        canRemove: !teamAssignment && !startDate,
        titleKey: 'delete.training',
      }),
    };
  };
